module.exports = __webpack_public_path__ + "img/女孩(2).f0e0c843.png";